import { RouterProvider } from "react-router-dom";
import { ApiProvider } from "@/app/providers/ApiProvider";
import { AuthProvider } from "@/app/providers/AuthProvider";
import { TenantProvider } from "@/app/providers/TenantProvider";
import { router } from "@/app/router";

export function App() {
  return (
    <TenantProvider>
      <AuthProvider>
        <ApiProvider>
          <RouterProvider router={router} />
        </ApiProvider>
      </AuthProvider>
    </TenantProvider>
  );
}